module.exports = __webpack_public_path__ + "img/icon-noface.9047039f.jpg";